import { useEffect, useState } from "react";
import {
  getConsent,
  hasDecided,
  onConsentChange,
} from "../lib/cookieConsent";

/**
 * Iter-185.L — React hook around the consent module.
 *
 * Returns `{ consent, decided }` and re-renders whenever the consent
 * record changes (banner submission, programmatic reset, etc.).
 * Use this hook to gate UI surfaces that depend on consent state
 * (e.g. the banner itself, the "Cookie settings" footer link).
 */
export function useCookieConsent() {
  const [state, setState] = useState(() => ({
    consent: getConsent(),
    decided: hasDecided(),
  }));

  useEffect(() => {
    const unsub = onConsentChange((next) => {
      setState({
        consent: next,
        decided: Boolean(next?.decided_at),
      });
    });
    // Re-sync on mount in case storage changed in another tab.
    setState({
      consent: getConsent(),
      decided: hasDecided(),
    });
    return () => unsub();
  }, []);

  return state;
}
